import EmojiEmotionsOutlinedIcon from "@mui/icons-material/EmojiEmotionsOutlined";
import { FoodsIcon } from "@foodpilot/foods";
import type { ReactionIconConfig } from "../types/reaction.types";

type ReactionIconProps = {
    config: Pick<ReactionIconConfig, "icon" | "muiIcon">;
    size: number;
};

const MUI_REACTION_ICONS = {
    emojiEmotions: EmojiEmotionsOutlinedIcon,
} as const;

export const ReactionIcon = ({ config, size }: ReactionIconProps) => {
    if (config.muiIcon) {
        const Icon = MUI_REACTION_ICONS[config.muiIcon];
        return <Icon sx={{ fontSize: 12 + 4 * size }} />;
    }

    return <FoodsIcon icon={config.icon} size={size} />;
};
